import { CreateOrderType, CreateOrderZod } from '@fd/common/biz/order';
import { normalize } from '@fd/common/normalize';

const generateUrlParams = (order: CreateOrderType) => {
  normalize(CreateOrderZod, order);
  const flatParams = {
    gateway: order.gateway,
    recurrent: String(order.recurrent),
    mobile_gb: String(order.mobileGb),
    residential_gb: String(order.residentialGb),
    datacenter_gb: String(order.datacenterGb),
  };
  const searchParamsStr = new URLSearchParams(flatParams).toString();
  console.log('generateRedirectToUrl', {
    flatParams,
    searchParamsStr,
  });
  return searchParamsStr;
};

export const generateLoginAndPayUrl = (params: CreateOrderType) => {
  return '/proxies/pay?' + generateUrlParams(params);
};
